import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import "./connect.css";

export default function Connect() {
  return (
    <div className="connect-container">
      {/* --- Floating WhatsApp Button --- */}
      <div className="contact-button">
        <a
          href="https://wa.me/918708753901"
          target="_blank"
          rel="noopener noreferrer"
          className="main-contact-btn whatsapp-btn"
        >
          <FontAwesomeIcon icon={faWhatsapp} />
        </a>
      </div>
    </div>
  );
}
